export default {
  // CATEGORIES
  CATEGORIES_REQUESTED: 'CATEGORIES_REQUESTED',
  CATEGORIES_LOADING: 'CATEGORIES_LOADING',
  CATEGORIES_SUCCESS: 'CATEGORIES_SUCCESS',
  CATEGORIES_ERROR: 'CATEGORIES_ERROR',
  CATEGORIES_CLEAR: 'CATEGORIES_CLEAR'
};
